// A short, friendly name for the device and browser a passkey was made on, e.g.
// "Chrome on Windows", used as the default nickname so a player can tell their
// passkeys apart in the list. It only reads the user-agent string, which is
// approximate on purpose: it is a label for a human, never a security check.

const BROWSERS: ReadonlyArray<[RegExp, string]> = [
  [/Edg(e|A|iOS)?\//, 'Edge'],
  [/OPR\/|Opera/, 'Opera'],
  [/SamsungBrowser\//, 'Samsung Internet'],
  [/Firefox\/|FxiOS\//, 'Firefox'],
  [/Chrome\/|CriOS\//, 'Chrome'],
  [/Safari\//, 'Safari'],
]

const SYSTEMS: ReadonlyArray<[RegExp, string]> = [
  [/iPhone/, 'iPhone'],
  [/iPad/, 'iPad'],
  [/Android/, 'Android'],
  [/Windows/, 'Windows'],
  [/Mac OS X|Macintosh/, 'Mac'],
  [/CrOS/, 'Chromebook'],
  [/Linux/, 'Linux'],
]

const match = (table: ReadonlyArray<[RegExp, string]>, userAgent: string): string | null =>
  table.find(([pattern]) => pattern.test(userAgent))?.[1] ?? null

export const describeThisDevice = (userAgent: string = globalThis.navigator?.userAgent ?? ''): string => {
  const browser = match(BROWSERS, userAgent)
  const system = match(SYSTEMS, userAgent)
  if (browser && system) return `${browser} on ${system}`
  return browser ?? system ?? 'This device'
}
